import React from 'react';
import { useStrings } from '@providers';
import { useCurrencyFormatter } from '@hooks/useCurrencyFormatter';
import { FormattedString } from '@components/Shared/FormattedString';
import { IContract } from 'src/types/IContract';

interface IProps {
  contract: IContract;
}

function DropdownContractLabel({ contract }: IProps) {
  const { termLabel } = useStrings();
  const formatCurrency = useCurrencyFormatter();

  return (
    <FormattedString
      string={termLabel}
      tagName="span"
      values={{
        price: formatCurrency(parseFloat(contract.price)),
        termSingular: contract.termLabelSingular,
      }}
    />
  );
}

export default DropdownContractLabel;
